const Backbone = require('backbone');
const _ = require('underscore');
const dispatcher = require('../dispatcher');
const spellcheckerView = require('../templates/spell-checker.jade');
const rawCaptionsDataExtractor = require('../helpers/raw-captions-data-extractor');
const spellchecker = require('../helpers/spellchecker');
const reader = require('../helpers/reader');
const languageContainer = require('../helpers/language-container');
const SubtitleScope = require('../scopes/subtitle');
const STATUSES = SubtitleScope.VARIABLES.STATUSES;

require('jquery-ui');

module.exports = Backbone.View.extend({
	events: {
		'click .jumpTo': 'captionSelected',
		'click .ignore': 'ignore',
		'click .ignoreAll': 'ignoreAll',
		'click .refresh-button': 'detectMispelledWords'
	},
	autoRender: true,
	initialize: function (params) {
		_.bindAll(this, 'render', 'createAndReturnMisspelledWordElement', 'detectMispelledWords', 'refreshView', 'captionSelected',
			'createAndReturnTableCell', 'createAndReturunActionsPanel');
		_.extend(this, params);

		this.undeletedCaptionModels = this.collection.models.filter(model => {
			return model.get('status') != STATUSES.DELETED
		});

		if (this.autoRender) this.render();
	},
	render: async function () {
		this.setElement(spellcheckerView());

		this.$el.draggable();

		await this.detectMispelledWords();

		return this;
	},
	captionSelected: function (e) {
		this.$el.find('tr.selected-misspelled-caption').removeClass('selected-misspelled-caption');
		let elementParentRow = this._findElementParent(e.currentTarget, "tr");
		$(elementParentRow).addClass('selected-misspelled-caption');

		let selectedCaptionId = e.currentTarget.getAttribute("captionId");
		let selectedCaptionIndex = rawCaptionsDataExtractor.getIndexById(this.collection.models, selectedCaptionId);
		this.jumpToCaption(selectedCaptionIndex);
	},
	detectMispelledWords: async function () {
		this.rawUndeletedCaptions = rawCaptionsDataExtractor.extractCaptionModels(this.undeletedCaptionModels);
		this.misspelledWordsToCaptionIds = await spellchecker.getMisspelledWordsOccurrences(this.rawUndeletedCaptions);
		this.refreshView();
	},
	refreshView: function () {
		let container = this.$(".misspelled-words-table");
		container.find("tbody,div").remove();
		let mispelledWords = Object.keys(this.misspelledWordsToCaptionIds);
		if (mispelledWords.length == 0) {
			let okMessageElemenet  = $("<div></div>").addClass("mispelled-words-ok-message").text("No mistake detected");
			container.append(okMessageElemenet);
		} else {
			mispelledWords.forEach(word => {
				container.append(this.createAndReturnMisspelledWordElement(word));
			});
		}
	},
	jumpToCaption: function (captionIndex) {
		let model = this.collection.at(captionIndex);

		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, captionIndex);
		dispatcher.emit(dispatcher.events.SCROLL_TO, captionIndex);
		dispatcher.emit(dispatcher.events.PLAY_SUBTITLE, model, 0);
	},
	ignore: function (e) {
		let captionId = e.currentTarget.getAttribute("captionId");
		let word = e.currentTarget.getAttribute("word");
		spellchecker.ignore(word, captionId);
		let parentRow = $(e.currentTarget).parents("tr").first();
		let parentRowGroup = parentRow.parent("tbody");
		parentRow.remove();
		if (parentRowGroup.children().length == 0) {
			parentRowGroup.remove();
		}
	},
	ignoreAll: function (e) {
		let word = e.currentTarget.getAttribute("word");
		spellchecker.ignoreAll(word);
		this.misspelledWordsToCaptionIds = spellchecker.filterIgnored(this.misspelledWordsToCaptionIds);
		this.refreshView();
	},
	createAndReturnMisspelledWordElement: function (word) {
		let captionRowsGroup = $("<tbody class='row word-row'></tbody>");
		let misspelledCaptions = this.misspelledWordsToCaptionIds[word];
		for (let i = 0; i < misspelledCaptions.length; i++) {
			let misspelledCaption = misspelledCaptions[i];
			let misspelledCaptionIndex = rawCaptionsDataExtractor.getIndexById(this.undeletedCaptionModels, misspelledCaption.id);
			let captionStartTimeCode = reader.framesToHMS(misspelledCaption.frameStart);
			let captionEndTimeCode = reader.framesToHMS(misspelledCaption.frameEnd);
			let captionTimeCodes = captionStartTimeCode + "<br>" + captionEndTimeCode;
			let captionText = misspelledCaption.row1 + "<br>" + misspelledCaption.row2;
			let captionHtml = captionText.replace(word, "<span class='misspelled-word'>" + word + "</span>");
			let captionRow = $("<tr class='row caption-index-row'></tr>");
			captionRow.append(this.createAndReturnTableCell(misspelledCaptionIndex + 1));
			captionRow.append(this.createAndReturnTableCell(captionTimeCodes));
			captionRow.append(this.createAndReturnTableCell(captionHtml, [{
				key: 'column-type',
				value: 'misspelled-caption-text'
			}]));
			captionRow.append(this.createAndReturunActionsPanel(word, misspelledCaption.id));
			captionRowsGroup.append(captionRow);
		}
		return captionRowsGroup;
	},
	createAndReturnTableCell: function (html, attributes) {
		let element = $("<td></td>").html(html);
		if (attributes) {
			attributes.forEach(attributeTuple => element.attr(attributeTuple.key, attributeTuple.value));
		}

		return element;
	},
	createAndReturunActionsPanel: function (word, misspelledCaptionId) {
		let actionsPanel = $("<div><div");
		let ignoreBtn = $("<button class='ignore'><button")
			.text("Ignore")
			.attr('captionId', misspelledCaptionId)
			.attr('word', word);
		let ignoreAllBtn = $("<button class='ignoreAll'><button")
			.text("Ignore All")
			.attr('word', word);
		let goToBtn = $("<button class='jumpTo'>GoTo<button")
			.attr('captionId', misspelledCaptionId)
			.text("Go To")

		actionsPanel.append(goToBtn);
		actionsPanel.append(ignoreBtn);
		actionsPanel.append(ignoreAllBtn);
		return actionsPanel;
	},
	_findElementParent(element, parentType) {
		parentType = parentType.toUpperCase();
		while(element.tagName !== parentType && element != null) {
			element = element.parentElement;
		}
		return element;
	}

});


// WEBPACK FOOTER //
// ./app/views/spellchecker-screen.js